exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maintenance-page {\n  min-height: 100vh;\n  padding: 20px;\n  box-sizing: border-box; }\n\n.maintenance-card {\n  width: 100%;\n  max-width: 620px;\n  text-align: center; }\n\nmd-card-header {\n  display: block;\n  color: #2c3e50;\n  font-size: 24px;\n  margin-bottom: 24px; }\n\nmd-card-content {\n  color: #555;\n  font-size: 17px;\n  line-height: 1.6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/maintenance/maintenance.component.scss
// module id = ../../../../../src/app/maintenance/maintenance.component.scss
// module chunks = 0